import { render, staticRenderFns } from "./r-item-deprecate-config.vue?vue&type=template&id=76283284"
import script from "./r-item-deprecate-config.vue?vue&type=script&lang=js"
export * from "./r-item-deprecate-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76283284')) {
      api.createRecord('76283284', component.options)
    } else {
      api.reload('76283284', component.options)
    }
    module.hot.accept("./r-item-deprecate-config.vue?vue&type=template&id=76283284", function () {
      api.rerender('76283284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/deprecate/r-item-deprecate-config.vue"
export default component.exports